<template>
    <!-- open eye -->
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
    <path d="M12.4342 0C7.40221 0 2.92192 2.93187 0 7.5C2.92192 12.0681 7.40221 15 12.4342 15C17.4662 15 21.9465 12.0681 24.8684 7.5C21.9465 2.93187 17.4662 0 12.4342 0ZM12.4342 12.5C9.68737 12.5 7.46053 10.2614 7.46053 7.5C7.46053 4.73863 9.68737 2.5 12.4342 2.5C15.1811 2.5 17.4079 4.73863 17.4079 7.5C17.4079 10.2614 15.1811 12.5 12.4342 12.5Z" fill="#004637"/>
    <path d="M12.4342 10.658C14.0692 10.658 15.3947 9.24411 15.3947 7.50006C15.3947 5.756 14.0692 4.34216 12.4342 4.34216C10.7991 4.34216 9.47363 5.756 9.47363 7.50006C9.47363 9.24411 10.7991 10.658 12.4342 10.658Z" fill="#004637"/>
    </svg>

 
</template>